import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CampaignCard = ({ campaign }) => {
  const navigate = useNavigate();

  const statusColors = {
    active: 'bg-success/10 text-success',
    pending: 'bg-warning/10 text-warning',
    completed: 'bg-muted text-muted-foreground',
    draft: 'bg-accent/10 text-accent'
  };

  const statusLabels = {
    active: 'Aktif',
    pending: 'Beklemede',
    completed: 'Tamamlandı',
    draft: 'Taslak'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-start gap-4 flex-1">
          <Image
            src={campaign?.image}
            alt={campaign?.imageAlt}
            className="w-16 h-16 rounded-lg object-cover"
          />
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-foreground mb-1 truncate">
              {campaign?.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-2">{campaign?.genre}</p>
            <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${statusColors?.[campaign?.status]}`}>
              <Icon name="Circle" size={8} className="fill-current" />
              <span>{statusLabels?.[campaign?.status]}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Influencer Sayısı</p>
          <p className="text-sm font-semibold text-foreground">{campaign?.influencerCount}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Toplam Bütçe</p>
          <p className="text-sm font-semibold text-foreground">{campaign?.budget}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Erişim</p>
          <p className="text-sm font-semibold text-foreground">{campaign?.reach}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Etkileşim</p>
          <p className="text-sm font-semibold text-foreground">{campaign?.engagement}</p>
        </div>
      </div>
      <div className="mb-4">
        <div className="flex items-center justify-between text-xs text-muted-foreground mb-2">
          <span>İlerleme</span>
          <span>{campaign?.progress}%</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-smooth"
            style={{ width: `${campaign?.progress}%` }}
          />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          fullWidth
          iconName="Eye"
          iconPosition="left"
          onClick={() => navigate(`/campaign-management?id=${campaign?.id}`)}
        >
          Detayları Gör
        </Button>
        <Button
          variant="default"
          size="sm"
          fullWidth
          iconName="MessageSquare"
          iconPosition="left"
          onClick={() => navigate(`/campaign-management?id=${campaign?.id}&tab=messages`)}
        >
          Mesajlar
        </Button>
      </div>
    </div>
  );
};

export default CampaignCard;